const defaultCompaniesState = () => {
    return {
        companies: [],
        companiesPagination: [],
        providers: []
    }
}
export default {
    namespaced: true,
    state: defaultCompaniesState(),
    mutations: {
        setCompanies(state, companies) {
            Object.assign(state, { companies });
        },
        setProviders(state, providers) {
            Object.assign(state, { providers });
        },
        setCompaniesPagination(state, companiesPagination) {
            Object.assign(state, { companiesPagination });
        },
        resetState(state) {
            Object.assign(state, defaultCompaniesState())
        }
    },
    actions: {}
}